import { render, staticRenderFns } from "./VpDialog.vue?vue&type=template&id=233bff7d&scoped=true&"
import script from "./VpDialog.vue?vue&type=script&lang=ts&"
export * from "./VpDialog.vue?vue&type=script&lang=ts&"
import style0 from "./VpDialog.vue?vue&type=style&index=0&id=233bff7d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233bff7d",
  null
  
)

export default component.exports